export default __webpack_public_path__ + "static/media/trial_ended.bf3cf3fc.svg";